/*
* This reducer file handles reducer's state for action that are related to show alert message.
*/
import _ from 'lodash';

const initialState = {
  items: [],
  text: null,
  status: 'ok',
  type: null
};

export default function notifications(state = initialState, action) {
  switch(action.type) {
    case 'NOTIFICATION_ADD':
      if(action.tokenStatus === 1){
        return false;
      }
      let items = _.clone(state.items);
      items.push({
        text: action.text,
        id: _.uniqueId(),
        status: action.status || 'ok',
        type: action.msgtype
      });
      return Object.assign({}, state, {
        items: items,
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Reducers/notifications.js